import { colors } from "styles/colors";

type Props = {
    className?: string;
  };

export const CosmeticsIcon: React.FC<Props> = ({ className = 'w-5 h-5' }) => {
  return (
    <svg width="19" height="22" viewBox="0 0 19 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path
        d="M17.5328 11H11.1328V20.6H17.5328V11Z"
        fill="white"
        stroke={colors.gray900}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.13281 4.97806V10.9999H6.86615V1.3999C3.83281 1.3999 3.13281 4.10536 3.13281 4.97806Z"
        stroke={colors.pink500}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.46667 11H1V20.6H8.46667V11Z"
        fill="white"
        stroke={colors.gray900}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 15.2666H8.46667"
        stroke={colors.gray900}
        strokeWidth="1.06667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
